"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ascrea": {
    "0d91339f": [{
      "hkey": "0424bc18",
      "slug": "ascrea",
      "name": "Ascrea",
      "primary": true,
      "skipSearch": false
    }],
    "obito": [{
      "hkey": "0424bc18",
      "slug": "ascrea",
      "name": "Ascrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60126c20": [{
      "hkey": "0f942ca8",
      "slug": "valleverde-stipes",
      "name": "Valleverde Stipes",
      "primary": true,
      "skipSearch": false
    }],
    "valleverde": [{
      "hkey": "0f942ca8",
      "slug": "valleverde-stipes",
      "name": "Valleverde Stipes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;